exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 720px) {\r\n  .mobileImageDisplay {\r\n    width: 100%\r\n  }\r\n\r\n  .pdf-viewer {\r\n    padding: 5px;\r\n    position: fixed;\r\n    top: 205px !important;\r\n    bottom: 8px;\r\n    clear: both;\r\n    border: 1px solid #607D8B;\r\n    background-color: #607D8B;\r\n    left: 8px !important;\r\n    right: 8px !important;\r\n  }\r\n\r\n  .container-btns {\r\n    margin-right: 8px;\r\n    margin-left: 8px;\r\n  }\r\n\r\n  h1 {\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n\r\n.pdf-viewer {\r\n  padding: 5px;\r\n  position: absolute;\r\n  top: 250px;\r\n  bottom: 25px;\r\n  clear: both;\r\n  border: 1px solid #2cbbc3;\r\n  background-color: #2cbbc3;\r\n  left: 10%;\r\n  right: 10%;\r\n}\r\n\r\n.container-btns {\r\n  margin-right: 10%;\r\n  margin-left: 10%;\r\n}\r\n\r\nmat-spinner.small-spinner svg { width: 40px !important; height: 40px !important; }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/documentDetail/documentDetail.component.css
// module id = ../../../../../src/app/components/documentDetail/documentDetail.component.css
// module chunks = main